export enum UnitTime {
  DAY = 'DAY',
  HOUR = 'HOUR',
}
